import { Grid } from '@progress/kendo-react-grid';
import { RefObject } from 'react';
import { GridColumn } from 'src/components/GridWrapper';

const useGlCodeMismatchColumns: (tableRef: RefObject<Grid>) => GridColumn<any>[] = () => {
  const glCodeMismatchColumns: GridColumn<any>[] = [
    {
      field: 'poNum',
      title: 'PO #',
      width: '150px',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'productItemNum',
      title: 'Item #',
      width: '150px',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'description',
      title: 'Description',
      width: '150px',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'poGlCd',
      title: 'PO GL Code',
      width: '150px',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'glCd',
      title: 'Doc Item GL Code',
      width: '150px',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'invoiceNumber',
      title: 'Doc #',
      width: '150px',
      dataType: 'string',
      menu: false,
    },
  ];
  return glCodeMismatchColumns;
};

export default useGlCodeMismatchColumns;
